import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { ArrowLeft } from "lucide-react";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export function EmbeddedCheckoutPanel({ clientSecret, onBack, note }) {
  return (
    <div data-testid="embedded-checkout-panel">
      <button
        onClick={onBack}
        data-testid="embedded-checkout-back"
        className="mb-4 text-sm text-[#8A9492] hover:text-ink flex items-center gap-1"
      >
        <ArrowLeft className="h-4 w-4" /> Back
      </button>
      {note && <p className="text-sm text-[#5C6664] mb-4">{note}</p>}
      <div id="checkout" data-testid="embedded-checkout">
        <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </div>
    </div>
  );
}
